import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import { MdArrowForwardIos, MdImage, MdMenu } from "react-icons/md";

import "../styles/Imprint.css";
import { useLocation, useNavigate } from "react-router";

export default function Imprint({ apiURL }) {
  const location = useLocation().pathname;
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="imprint">
      <div className="imprint_topnav">
        <div className="imprint_topnav_left">
          <div className="home_topnav_left_back" onClick={() => navigate("/")}>
            Return
          </div>
        </div>
      </div>
      <div className="imprint_body">
        <h1>Imprint</h1>
        <h2>Information according to § 5 TMG</h2>
        <p>
          Servist Software GmbH
          <br />
          Neißestraße 1<br />
          14513 Teltow
        </p>
        <p>
          Commercial register: HRB 37780 P
          <br />
          Register court: District Court of Potsdam
        </p>
        <p>
          <strong>Represented by:</strong>
          <br />
          Masih Minawal
        </p>
        <h2>Contact</h2>
        <p>Email: info@servist.de</p>
        <h2>EU Dispute Resolution</h2>
        <p>
          The European Commission provides a platform for online dispute
          resolution (ODR):
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr/
          </a>
          .<br /> You can find our email address above in the imprint.
        </p>
        <h2>Consumer Dispute Resolution/Universal Arbitration Board</h2>
        <p>
          We are not willing or obligated to participate in dispute resolution
          proceedings before a consumer arbitration board.
        </p>
        <h2>Disclaimer:</h2>
        <h4>Liability for Contents</h4>
        <p>
          As a service provider, we are responsible for our own content on these
          pages according to general laws as per § 7 para.1 TMG. According to §§
          8 to 10 TMG, we are not obliged to monitor transmitted or stored
          third-party information or investigate circumstances that indicate
          illegal activity. Obligations to remove or block the use of
          information under general laws remain unaffected. Liability in this
          respect is only possible from the time we become aware of a specific
          legal violation. Upon becoming aware of such violations, we will
          remove the content immediately.
        </p>
        <h4>Liability for Links</h4>
        <p>
          Our offer contains links to external third-party websites, on whose
          content we have no influence. Therefore, we cannot assume any
          liability for these external contents. The respective provider or
          operator of the pages is always responsible for the content of the
          linked pages. The linked pages were checked for possible legal
          violations at the time of linking. Illegal contents were not
          identifiable at the time of linking. A permanent control of the
          contents of linked pages is not reasonable without concrete evidence
          of a violation. Upon becoming aware of violations, we will remove such
          links immediately.
        </p>
        <h4>Copyright</h4>
        <p>
          The content and works created by the site operators on these pages are
          subject to German copyright law. Duplication, processing,
          distribution, and any kind of exploitation outside the limits of
          copyright require the written consent of the respective author or
          creator. Downloads and copies of this site are only permitted for
          private, non-commercial use. Insofar as the content on this site was
          not created by the operator, the copyrights of third parties are
          respected. In particular, third-party content is marked as such. If
          you nevertheless become aware of a copyright infringement, please let
          us know. Upon becoming aware of violations, we will remove such
          content immediately.
        </p>
        <h1>Privacy Policy</h1>
        <h2>1. Overview of Data Protection</h2>
        <h3>General Information</h3>
        <p>
          The following information provides a simple overview of what happens
          to your personal data when you visit this website. Personal data is
          any data with which you can be personally identified. Detailed
          information on data protection can be found in our privacy policy
          below.
        </p>
        <h3>Data Collection on This Website</h3>
        <h4>Who is responsible for data collection on this website?</h4>
        <p>
          Data processing on this website is carried out by the website
          operator. Their contact details can be found in the section
          "Information on the responsible party" in this privacy policy.
        </p>
        <h4>How do we collect your data?</h4>
        <p>
          Your data is collected in part by you providing it to us. This may,
          for example, be data you enter in a contact form.
        </p>
        <p>
          Other data is collected automatically or with your consent when you
          visit the website by our IT systems. These are mainly technical data
          (e.g., internet browser, operating system, or time of page view). This
          data is collected automatically as soon as you enter this website.
        </p>
        <h4>What do we use your data for?</h4>
        <p>
          Part of the data is collected to ensure the website is provided
          without errors. Other data may be used to analyze your user behavior.
        </p>
        <h4>What rights do you have regarding your data?</h4>
        <p>
          You have the right to receive information free of charge at any time
          about the origin, recipient, and purpose of your stored personal data.
          You also have the right to request correction or deletion of this
          data. If you have given consent to data processing, you can revoke
          this consent at any time for the future. Furthermore, you have the
          right, under certain circumstances, to request the restriction of the
          processing of your personal data. You also have the right to lodge a
          complaint with the competent supervisory authority.
        </p>
        <p>
          You can contact us at any time about this and other questions
          regarding data protection.
        </p>
        <h2>2. Hosting</h2>
        <p>We host the content of our website with the following provider:</p>
        <h3>All-Inkl</h3>
        <p>
          Provider is ALL-INKL.COM - Neue Medien Münnich, Inh. René Münnich,
          Hauptstraße 68, 02742 Friedersdorf (hereinafter All-Inkl). Details can
          be found in All-Inkl's privacy policy:{" "}
          <a
            href="https://all-inkl.com/datenschutzinformationen/"
            target="_blank"
            rel="noopener noreferrer">
            https://all-inkl.com/datenschutzinformationen/
          </a>
          .
        </p>
        <p>
          The use of All-Inkl is based on Art. 6 para. 1 lit. f GDPR. We have a
          legitimate interest in the most reliable presentation of our website.
          If appropriate consent has been requested, the processing is based
          solely on Art. 6 para. 1 lit. a GDPR and § 25 para. 1 TTDSG, as far as
          the consent includes the storage of cookies or access to information
          on the user's terminal device (e.g. device fingerprinting) in
          accordance with the TTDSG. The consent can be revoked at any time.
        </p>
        <h4>Data Processing Agreement</h4>
        <p>
          We have concluded a data processing agreement (DPA) for the use of the
          above service. This is a contract required by data protection law,
          which ensures that this service processes the personal data of our
          website visitors only in accordance with our instructions and in
          compliance with the GDPR.
        </p>
        <h2>3. General Notes and Mandatory Information</h2>
        <h3>Data Protection</h3>
        <p>
          The operators of these pages take the protection of your personal data
          very seriously. We treat your personal data confidentially and in
          accordance with the statutory data protection regulations and this
          privacy policy.
        </p>
        <p>
          When you use this website, various personal data is collected.
          Personal data is data with which you can be personally identified.
          This privacy policy explains what data we collect and what we use it
          for. It also explains how and for what purpose this happens.
        </p>
        <p>
          We point out that data transmission on the internet (e.g.,
          communication by email) can have security gaps. A complete protection
          of the data against access by third parties is not possible.
        </p>

        <h3>Notice on the Responsible Entity</h3>
        <p>The responsible entity for data processing on this website is:</p>
        <p>Servist Software GmbH, Neißestraße 1, 14513 Teltow</p>
        <p>Email: info@servist.de</p>
        <p>
          The responsible entity is the natural or legal person who alone or
          jointly with others decides on the purposes and means of processing
          personal data (e.g., names, email addresses, etc.).
        </p>
        <h3>Storage Duration</h3>
        <p>
          Unless a more specific storage period is mentioned in this privacy
          policy, your personal data will remain with us until the purpose for
          data processing no longer applies. If you make a legitimate request
          for deletion or revoke your consent to data processing, your data will
          be deleted unless we have other legally permissible reasons for
          storing your personal data (e.g., retention periods under tax or
          commercial law); in the latter case, deletion takes place after these
          reasons no longer apply.
        </p>
        <h3>
          General Information on the Legal Bases of Data Processing on this
          Website
        </h3>
        <p>
          If you have consented to data processing, we process your personal
          data on the basis of Art. 6(1)(a) GDPR or Art. 9(2)(a) GDPR, if
          special data categories are processed according to Art. 9(1) GDPR. In
          the event of explicit consent to the transfer of personal data to
          third countries, data processing is also based on Art. 49(1)(a) GDPR.
          If you have consented to the storage of cookies or access to
          information on your end device (e.g., via device fingerprinting), data
          processing is also based on § 25(1) TTDSG. Consent can be revoked at
          any time. If your data is required to fulfill a contract or to carry
          out pre-contractual measures, we process your data based on Art.
          6(1)(b) GDPR. Furthermore, we process your data if required to fulfill
          a legal obligation based on Art. 6(1)(c) GDPR. Data processing may
          also be based on our legitimate interest under Art. 6(1)(f) GDPR. The
          relevant legal bases in each individual case are explained in this
          privacy policy.
        </p>
        <h3>Revocation of Your Consent to Data Processing</h3>
        <p>
          Many data processing operations are only possible with your explicit
          consent. You can revoke consent at any time. The legality of the data
          processing carried out until the revocation remains unaffected by the
          revocation.
        </p>
        <h3>
          Right to Object to Data Collection in Special Cases and to Direct
          Marketing (Art. 21 GDPR)
        </h3>
        <p>
          IF DATA PROCESSING IS BASED ON ART. 6(1)(E) OR (F) GDPR, YOU HAVE THE
          RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF YOUR PERSONAL DATA
          FOR REASONS ARISING FROM YOUR PARTICULAR SITUATION; THIS ALSO APPLIES
          TO PROFILING BASED ON THESE PROVISIONS. THE RESPECTIVE LEGAL BASIS FOR
          PROCESSING CAN BE FOUND IN THIS PRIVACY POLICY. IF YOU OBJECT, WE WILL
          NO LONGER PROCESS YOUR PERSONAL DATA UNLESS WE CAN DEMONSTRATE
          COMPELLING LEGITIMATE GROUNDS FOR THE PROCESSING WHICH OVERRIDE YOUR
          INTERESTS, RIGHTS AND FREEDOMS OR THE PROCESSING SERVES THE ASSERTION,
          EXERCISE OR DEFENSE OF LEGAL CLAIMS (OBJECTION PURSUANT TO ART. 21(1)
          GDPR).
        </p>
        <p>
          IF YOUR PERSONAL DATA IS PROCESSED FOR DIRECT MARKETING PURPOSES, YOU
          HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF YOUR
          PERSONAL DATA FOR SUCH MARKETING; THIS ALSO APPLIES TO PROFILING TO
          THE EXTENT THAT IT IS RELATED TO SUCH DIRECT MARKETING. IF YOU OBJECT,
          YOUR PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT
          MARKETING PURPOSES (OBJECTION PURSUANT TO ART. 21(2) GDPR).
        </p>
        <h3>
          Right to Lodge a Complaint with the Competent Supervisory Authority
        </h3>
        <p>
          In the event of breaches of the GDPR, data subjects have a right to
          lodge a complaint with a supervisory authority, particularly in the
          Member State of their habitual residence, place of work or place of
          the alleged infringement. The right to lodge a complaint is without
          prejudice to any other administrative or judicial remedy.
        </p>
        <h3>Right to Data Portability</h3>
        <p>
          You have the right to have data that we process automatically based on
          your consent or in fulfillment of a contract handed over to you or to
          a third party in a common, machine-readable format. If you request
          direct transfer of the data to another controller, this will only be
          done to the extent technically feasible.
        </p>
        <h3>Right of Access, Rectification, and Erasure</h3>
        <p>
          You have the right at any time, within the framework of the applicable
          legal provisions, to obtain free information about your stored
          personal data, its origin and recipient and the purpose of data
          processing and, if necessary, a right to rectification or erasure of
          this data. You can contact us at any time regarding this and other
          questions on the subject of personal data.
        </p>
        <h3>Right to Restriction of Processing</h3>
        <p>
          You have the right to request the restriction of processing of your
          personal data. You can contact us at any time for this. The right to
          restriction of processing exists in the following cases:
        </p>
        <ul>
          <li>
            If you contest the accuracy of your personal data stored by us, we
            usually need time to verify this. For the duration of the review,
            you have the right to request restriction of processing of your
            personal data.
          </li>
          <li>
            If the processing of your personal data was/is unlawful, you can
            request restriction of data processing instead of deletion.
          </li>
          <li>
            If we no longer need your personal data, but you need it to
            exercise, defend or assert legal claims, you have the right to
            request restriction of the processing of your personal data instead
            of deletion.
          </li>
          <li>
            If you have objected pursuant to Art. 21(1) GDPR, a balance must be
            struck between your and our interests. As long as it is not yet
            clear whose interests prevail, you have the right to request
            restriction of processing of your personal data.
          </li>
        </ul>
        <p>
          If you have restricted the processing of your personal data, such data
          may – apart from being stored – only be processed with your consent or
          for the assertion, exercise or defense of legal claims or for the
          protection of the rights of another natural or legal person or for
          reasons of important public interest of the European Union or a Member
          State.
        </p>
        <h3>SSL or TLS Encryption</h3>
        <p>
          For security reasons and to protect the transmission of confidential
          content, such as orders or inquiries you send to us as the site
          operator, this site uses SSL or TLS encryption. You can recognize an
          encrypted connection by the browser’s address line changing from
          "http://" to "https://" and the lock icon in your browser bar.
        </p>
        <p>
          When SSL or TLS encryption is activated, the data you transmit to us
          cannot be read by third parties.
        </p>
        <h2>4. Data Collection on this Website</h2>
        <h3>Server Log Files</h3>
        <p>
          The provider of the pages automatically collects and stores
          information in so-called server log files, which your browser
          automatically transmits to us. These are:
        </p>
        <ul>
          <li>Browser type and browser version</li>
          <li>Operating system used</li>
          <li>Referrer URL</li>
          <li>Host name of the accessing computer</li>
          <li>Time of the server request</li>
          <li>IP address</li>
        </ul>
        <p>This data is not merged with other data sources.</p>
        <p>
          The collection of this data is based on Art. 6(1)(f) GDPR. The website
          operator has a legitimate interest in the technically error-free
          presentation and optimization of their website – for this, the server
          log files must be recorded.
        </p>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ImageIcon = styled(MdImage)`
  font-size: 42px;
  color: #474747;
`;
